import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, mergeProps as _mergeProps, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, createBlock as _createBlock, unref as _unref, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4d2de57f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex justify-space-between align-center mb-10" }
const _hoisted_2 = { class: "d-flex align-center" }
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 1,
  class: "text-h6"
}
const _hoisted_5 = { class: "d-flex align-center" }
const _hoisted_6 = ["src"]
const _hoisted_7 = {
  key: 1,
  class: "text-h6"
}
const _hoisted_8 = { class: "text-bold align-center text-gray-800 ms-3" }
const _hoisted_9 = { class: "text-bold align-center text-md text-gray-950" }
const _hoisted_10 = {
  key: 0,
  class: "subtitle"
}
const _hoisted_11 = { class: "grey text-xs no-wrap-text" }
const _hoisted_12 = { class: "text-bold text-xs text-gray-950 no-wrap-text" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "mt-4" }, " Motivo ", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { style: {"margin-bottom":"1.6%","color":"transparent"} }, " Ver detalhes ", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "mb-2" }, " Possui Exceção? ", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "text-bold mb-6" }, "Sazonalidade", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "text-bold" }, "Gatilhos", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "text-bold mb-6" }, null, -1))

import { toRefs, watch, ref, computed } from 'vue';
import { AtomBadge, AtomButton, AtomInput, AtomInputBrands, AtomProgressBar, AtomTableModal, AtomToogleButton, AtomSelect } from '@/components/atoms';
import { MoleculeModalGoal, MoleculeTableSmall, MoleculeTableSmallModal2, MoleculeModalAlert, MoleculeModalGoalsGroup } from '@/components/molecules'
import { IBrandsDetailMeta, IDataCommission, IHeadersTable, IOrientationGoal, ISeasonality, IToggleButon, IOptionsSelect, PageData, Source } from '@/types';
import { Brand, Goal, Resale, User, Warehouse } from '@/core/model';
import { format } from 'date-fns';
import { getPaginate as getBrands } from '@/core/service/BrandsService';
import { getPaginate as getResales } from '@/core/service/ResalesService';
import { getPaginate as getUsers } from '@/core/service/UsersService';
import { getPaginate as getWarehouses } from '@/core/service/WarehousesService';
import { update, updateBrands, updateUsersException, updateBrandsException, updateResalesException, updateWarehousesException } from '@/core/service/GoalsService';
import { Preloader, Authentication } from '@/store';
import Swal from 'sweetalert2';
import { formatCurrency, formatPercentage, formatTriggerItemPercentageLabel } from '@/utils/formatNumber';
import { useRouter } from 'vue-router';

interface IProps {
  name: string;
  row: IDataCommission[],
  email: string;
  iconBrand: string;
  badgeText: string
  badgeColor: string
  badgeTextColor: string
  isProgress?: boolean
  progress?: number
  orientation: IOrientationGoal[]
  goal: Goal
}

export default /*#__PURE__*/_defineComponent({
  __name: 'MoleculeGoal',
  props: {
    name: {},
    row: {},
    email: {},
    iconBrand: {},
    badgeText: {},
    badgeColor: {},
    badgeTextColor: {},
    isProgress: { type: Boolean },
    progress: {},
    orientation: {},
    goal: {}
  },
  emits: ['handleLoad'],
  setup(__props: any, { emit: __emit }) {

const router = useRouter();

const showGoalGroup = ref<boolean>(false);
function showModalGoalGroup() {
  showGoalGroup.value = true;
}

const emit = __emit;
const actives = ref<IToggleButon[]>([
  { text: "Ativa", value: '1' },
  { text: "Inativa", value: '0' },
]);

const exceptions = ref<IToggleButon[]>([
  { text: "Sim", value: '1' },
  { text: "Não", value: '0' },
])

const showModal = ref<boolean>(false);

const pagination = ref<PageData[]>([
  {
    source: 'resale',
    page: 0,
    enableToLoad: true
  },
  {
    source: 'brand',
    page: 0,
    enableToLoad: true
  },
  {
    source: 'warehouse',
    page: 0,
    enableToLoad: true
  },
  {
    source: 'trigger',
    page: 0,
    enableToLoad: true
  },
  {
    source: 'user',
    page: 0,
    enableToLoad: true
  },
  {
    source: 'season',
    page: 0,
    enableToLoad: true
  }
]);

function auxFunction(){
  pagination.value.find((p) => p.source === 'brand')!.page = 1
}

const brands = ref<Brand[]>([]);
const brands_exception = ref<Brand[]>([]);
const brandsComputed = computed(() => {
  const goalBrandIds = goal.value.brands?.flatMap(brand => brand.id);
  
  return brands.value.filter(f => { return f.name != "- Nenhum fabricante -" }).filter((b) => { return !goalBrandIds?.includes(b.id); })
  .map(f => {
    return { text: f.name, value: f.id } as IOptionsSelect;
  });
});
const brands_to_add = ref<number[]>([]);
const can_edit_brands = ref<boolean>(false);
const isSearching = ref<boolean>(false);
const filteredData = ref<IOptionsSelect[]>([]);

const users_exception = ref<User[]>([]);
const isSearchingUser = ref<boolean>(false);
const users_exception_to_add = ref<number[]>([]);
const can_edit_users_exception = ref<boolean>(false);
const filteredDataUserException = ref<IOptionsSelect[]>([]);
const usersComputed = computed(() => {
  return users_exception.value.filter(f => !f.is_master).map(f => {
    return { text: f.name, value: f.id } as IOptionsSelect
  });
});

const brands_exception_to_add = ref<number[]>([]);
const can_edit_brands_exception = ref<boolean>(false);
const filteredDataBrandException = ref<IOptionsSelect[]>([]);
const selectedBrandExceptionData = ref<IOptionsSelect[]>([]);
const optionsBrandExceptionComputed = computed(() => {
  return filteredDataBrandException.value.length ? [...selectedBrandExceptionData.value, ...filteredDataBrandException.value].filter((value, index, self) => index === self.findIndex((t) => ( t.value === value.value ))) : selectedBrandExceptionData.value.length ? [...selectedBrandExceptionData.value, ...brandsComputed.value].filter((value, index, self) => index === self.findIndex((t) => ( t.value === value.value ))) : brandsComputed.value;
});

const resales_exception = ref<Resale[]>([]);
const isSearchingResale = ref<boolean>(false);
const resales_exception_to_add = ref<number[]>([]);
const can_edit_resales_exception = ref<boolean>(false);
const filteredDataResaleException = ref<IOptionsSelect[]>([]);
const selectedResaleExceptionData = ref<IOptionsSelect[]>([]);
const optionsResaleExceptionComputed = computed(() => {
  return filteredDataResaleException.value.length ? [...selectedResaleExceptionData.value, ...filteredDataResaleException.value].filter((value, index, self) => index === self.findIndex((t) => ( t.value === value.value ))) : selectedResaleExceptionData.value.length ? [...selectedResaleExceptionData.value, ...resalesComputed.value].filter((value, index, self) => index === self.findIndex((t) => ( t.value === value.value ))) : resalesComputed.value;
});
const resalesComputed = computed(() => {
  return resales_exception.value.map(f => {
    return { text: f.sap_card_code + " - " + f.sap_card_name, value: f.id } as IOptionsSelect
  });
});

const warehouses_exception = ref<Warehouse[]>([]);
const isSearchingWarehouse = ref<boolean>(false);
const warehouses_exception_to_add = ref<number[]>([]);
const can_edit_warehouses_exception = ref<boolean>(false);
const filteredDataWarehouseException = ref<IOptionsSelect[]>([]);
const selectedWarehouseExceptionData = ref<IOptionsSelect[]>([]);
const optionsWarehouseExceptionComputed = computed(() => {
  return filteredDataWarehouseException.value.length ? [...selectedWarehouseExceptionData.value, ...filteredDataWarehouseException.value].filter((value, index, self) => index === self.findIndex((t) => ( t.value === value.value ))) : selectedWarehouseExceptionData.value.length ? [...selectedWarehouseExceptionData.value, ...warehousesComputed.value].filter((value, index, self) => index === self.findIndex((t) => ( t.value === value.value ))) : warehousesComputed.value;
});
const warehousesComputed = computed(() => {
  return warehouses_exception.value.map(f => {
    return { text: f.sap_code + " - " + f.name, value: f.id } as IOptionsSelect
  });
});

function nextPagination(source: Source, cb: any) {
  setTimeout(() => {
    const index = pagination.value.findIndex((p) => p.source === source);

    pagination.value[index].page++;

    cb();
  }, 500)
}

function loadBrands() {
  const page = pagination.value.find((p) => p.source === "brand");
  getBrands(page?.page ?? 1)
    .then((resp) => {
      if (page) page.enableToLoad = resp.data.length ?? false;

      brands.value.push(...resp.data ?? []);
    });
}

const filteredSearch = (value) => {
  if (!isSearching.value && value.length >= 3)
  {
    isSearching.value = true;
    const goalBrandIds = goal.value.brands?.flatMap(brand => brand.id);

    setTimeout(() => {
      filteredData.value = brands.value.filter(f => { return f.name != "- Nenhum fabricante -" })
      .filter((b) => { return !goalBrandIds?.includes(b.id); })
      .map(f => {
        return { text: f.name, value: f.id } as IOptionsSelect;
      });
    }, 3000);

    return;
  }

  filteredData.value = [];
  isSearching.value = false;
}

const filteredSearchBrandException = (value) => {
  if (!isSearching.value && value.length >= 3) {
    isSearching.value = true;
    
    setTimeout(() => {
      filteredDataBrandException.value = [];
      getBrands(undefined, undefined, value)
        .then((resp) => {
          // Cria uma cópia do selectedBrandExceptionData
          const brandExceptionDataCopy = [...selectedBrandExceptionData.value];
          filteredDataBrandException.value = brandExceptionDataCopy;

          filteredDataBrandException.value.push(...(resp.data ?? [])
            .filter(f => f.name !== "- Nenhum fabricante -")
            .filter(f => filteredDataBrandException.value.findIndex((i) => { return i.value == f.id }) == -1)
            .map(f => ({
              text: f.name,
              value: f.id
            }) as IOptionsSelect)
          );

          isSearching.value = false;
        });
    }, 3000);

    return;
  }

  filteredDataBrandException.value = [];
};

function editBrand()
{
  // Limpa os dados
  can_edit_brands.value = false;
  brands_to_add.value = [];
  brands.value = [];

  can_edit_brands.value = true;
}

function handleEditBrand()
{
  if(brands_to_add.value.length > 0)
  {
    Preloader.actions.ActionSetPreloader(true);
    updateBrands(goal.value.id as number, brands_to_add.value).then(f => {
      Swal.fire({
        text: "Meta alterada com sucesso",
        title: "Sucesso",
        icon: 'success'
      });
      // Atualiza a lista de brands no goal para exibir no modal
      brands.value = brands.value.filter((b) => { return brands_to_add.value.includes(b.id!) } );
      goal.value.brands?.push(...brands.value);
    }).finally(() => {
      // Limpa os dados
      can_edit_brands.value = false;
      brands_to_add.value = [];
      brands.value = [];

      Preloader.actions.ActionSetPreloader(false);
    });
  }
  else
  {
    // Limpa os dados
    can_edit_brands.value = false;
    brands_to_add.value = [];
    brands.value = [];
  }
}

const handleBrandExceptionSelection = (value) => {
  selectedBrandExceptionData.value = (filteredDataBrandException.value.length ? [...selectedBrandExceptionData.value, ...filteredDataBrandException.value].filter((value, index, self) => index === self.findIndex((t) => ( t.value === value.value ))) : selectedBrandExceptionData.value.length ? [...selectedBrandExceptionData.value, ...brandsComputed.value].filter((value, index, self) => index === self.findIndex((t) => ( t.value === value.value ))) : brandsComputed.value).filter(f => 
    value.includes(f.value)
  );
}

function loadUsersException()
{
  getUsers(undefined, undefined, undefined, true).then((resp) => {
    users_exception.value = resp.data;
  });
}

const filteredSearchUserException = (value) => {
  if (!isSearchingUser.value && value.length >= 3) {
    isSearchingUser.value = true
    
    setTimeout(() => {
      getUsers(undefined, undefined, value)
        .then((resp) => {
          filteredDataUserException.value = (resp.data ?? [])
          .map(f => {
              return { text: f.name, value: f.id } as IOptionsSelect
          });
          isSearchingUser.value = false;
      });
    }, 3000);

    return;
  }

  filteredDataUserException.value = [];
  isSearchingUser.value = false;
}

function editUserException()
{
  // Limpa os dados
  can_edit_users_exception.value = false;
  users_exception_to_add.value = [];
  users_exception.value = [];

  can_edit_users_exception.value = true;
}

function handleEditUserException()
{
  if(users_exception_to_add.value.length > 0)
  {
    Preloader.actions.ActionSetPreloader(true);
    updateUsersException(goal.value.id as number, users_exception_to_add.value).then(f => {
      Swal.fire({
        text: "Meta alterada com sucesso",
        title: "Sucesso",
        icon: 'success'
      });
      // Atualiza a lista de users_exception no goal para exibir no modal
      users_exception.value = users_exception.value.filter((b) => { return users_exception_to_add.value.includes(b.id!) } );
      goal.value.users_exceptions?.push(...users_exception.value);
    }).finally(() => {
      // Limpa os dados
      can_edit_users_exception.value = false;
      users_exception_to_add.value = [];
      users_exception.value = [];

      Preloader.actions.ActionSetPreloader(false);
    });
  }
  else
  {
    // Limpa os dados
    can_edit_users_exception.value = false;
    users_exception_to_add.value = [];
  }
}

function editBrandException()
{
  // Limpa os dados
  can_edit_brands_exception.value = false;
  brands_exception_to_add.value = [];
  brands_exception.value = [];

  can_edit_brands_exception.value = true;
}

function handleEditBrandException()
{
  if(brands_exception_to_add.value.length > 0)
  {
    Preloader.actions.ActionSetPreloader(true);
    updateBrandsException(goal.value.id as number, brands_exception_to_add.value).then(f => {
      Swal.fire({
        text: "Meta alterada com sucesso",
        title: "Sucesso",
        icon: 'success'
      });
      // Atualiza a lista de brands_exception no goal para exibir no modal
      brands_exception.value = brands_exception.value.filter((b) => { return brands_exception_to_add.value.includes(b.id!) } );
      goal.value.brands_exceptions?.push(...brands_exception.value);
    }).finally(() => {
      // Limpa os dados
      can_edit_brands_exception.value = false;
      brands_exception_to_add.value = [];
      brands_exception.value = [];

      Preloader.actions.ActionSetPreloader(false);
    });
  }
  else
  {
    // Limpa os dados
    can_edit_brands_exception.value = false;
    brands_exception_to_add.value = [];
  }
}

function loadResalesException()
{
  const page = pagination.value.find((p) => p.source === "resale");
  getResales(page?.page ?? 1)
    .then((resp) => {
      if (page) page.enableToLoad = resp.data.length ?? false;

      resales_exception.value.push(...resp.data ?? []);
    });
}

const filteredSearchResaleException = (value) => {
  if (!isSearchingResale.value && value.length >= 3) {
    isSearchingResale.value = true;
    
    setTimeout(() => {
      filteredDataResaleException.value = [];
      getResales(undefined, undefined, value)
        .then((resp) => {
          // Cria uma cópia do selectedResaleExceptionData
          const resaleExceptionDataCopy = [...selectedResaleExceptionData.value];
          filteredDataResaleException.value = resaleExceptionDataCopy;

          filteredDataResaleException.value.push(...(resp.data ?? [])
            .filter(f => filteredDataResaleException.value.findIndex((i) => { return i.value == f.id }) == -1)
            .map(f => {
                return { text: f.sap_card_code + " - " + f.sap_card_name, value: f.id } as IOptionsSelect
            })
          );

          isSearchingResale.value = false;
        });
    }, 3000);

    return;
  }

  filteredDataResaleException.value = [];
};

function editResaleException()
{
  // Limpa os dados
  can_edit_resales_exception.value = false;
  resales_exception_to_add.value = [];
  resales_exception.value = [];

  can_edit_resales_exception.value = true;
}

function handleEditResaleException()
{
  if(resales_exception_to_add.value.length > 0)
  {
    Preloader.actions.ActionSetPreloader(true);
    updateResalesException(goal.value.id as number, resales_exception_to_add.value).then(f => {
      Swal.fire({
        text: "Meta alterada com sucesso",
        title: "Sucesso",
        icon: 'success'
      });
      // Atualiza a lista de resales_exception no goal para exibir no modal
      resales_exception.value = resales_exception.value.filter((b) => { return resales_exception_to_add.value.includes(b.id!) } );
      goal.value.resales_exceptions?.push(...resales_exception.value);
    }).finally(() => {
      // Limpa os dados
      can_edit_resales_exception.value = false;
      resales_exception_to_add.value = [];
      resales_exception.value = [];

      Preloader.actions.ActionSetPreloader(false);
    });
  }
  else
  {
    // Limpa os dados
    can_edit_resales_exception.value = false;
    resales_exception_to_add.value = [];
  }
}

const handleResaleExceptionSelection = (value) => {
  selectedResaleExceptionData.value = (filteredDataResaleException.value.length ? [...selectedResaleExceptionData.value, ...filteredDataResaleException.value].filter((value, index, self) => index === self.findIndex((t) => ( t.value === value.value ))) : selectedResaleExceptionData.value.length ? [...selectedResaleExceptionData.value, ...resalesComputed.value].filter((value, index, self) => index === self.findIndex((t) => ( t.value === value.value ))) : resalesComputed.value).filter(f => 
    value.includes(f.value)
  );
}

function loadWarehousesException()
{
  getWarehouses(undefined, undefined, undefined, true).then((resp) => {
    warehouses_exception.value = resp.data;
  });
}

const filteredSearchWarehousesException = (value) => {
  if (!isSearchingWarehouse.value && value.length >= 3) {
    isSearchingWarehouse.value = true;
    
    setTimeout(() => {
      filteredDataWarehouseException.value = [];
      getWarehouses(undefined, undefined, value)
        .then((resp) => {
          // Cria uma cópia do selectedWarehouseExceptionData
          const warehouseExceptionDataCopy = [...selectedWarehouseExceptionData.value];
          filteredDataWarehouseException.value = warehouseExceptionDataCopy;

          filteredDataWarehouseException.value.push(...(resp.data ?? [])
            .filter(f => filteredDataWarehouseException.value.findIndex((i) => { return i.value == f.id }) == -1)
            .map(f => {
              return { text: f.sap_code + " - " + f.name, value: f.id } as IOptionsSelect
            })
          );

          isSearchingWarehouse.value = false;
        });
    }, 3000);

    return;
  }

  filteredDataWarehouseException.value = [];
}

function editWarehouseException()
{
  // Limpa os dados
  can_edit_warehouses_exception.value = false;
  warehouses_exception_to_add.value = [];
  warehouses_exception.value = [];

  can_edit_warehouses_exception.value = true;
}

function handleEditWarehousesException()
{
  if(warehouses_exception_to_add.value.length > 0)
  {
    Preloader.actions.ActionSetPreloader(true);
    updateWarehousesException(goal.value.id as number, warehouses_exception_to_add.value).then(f => {
      Swal.fire({
        text: "Meta alterada com sucesso",
        title: "Sucesso",
        icon: 'success'
      });
      // Atualiza a lista de warehouses_exception no goal para exibir no modal
      warehouses_exception.value = warehouses_exception.value.filter((b) => { return warehouses_exception_to_add.value.includes(b.id!) } );
      goal.value.warehouses_exceptions?.push(...warehouses_exception.value);
    }).finally(() => {
      // Limpa os dados
      can_edit_warehouses_exception.value = false;
      warehouses_exception_to_add.value = [];
      warehouses_exception.value = [];

      Preloader.actions.ActionSetPreloader(false);
    });
  }
  else
  {
    // Limpa os dados
    can_edit_warehouses_exception.value = false;
    warehouses_exception_to_add.value = [];
  }
}

const handleWarehouseExceptionSelection = (value) => {
  selectedWarehouseExceptionData.value = (filteredDataWarehouseException.value.length ? [...selectedWarehouseExceptionData.value, ...filteredDataWarehouseException.value].filter((value, index, self) => index === self.findIndex((t) => ( t.value === value.value ))) : selectedWarehouseExceptionData.value.length ? [...selectedWarehouseExceptionData.value, ...warehousesComputed.value].filter((value, index, self) => index === self.findIndex((t) => ( t.value === value.value ))) : warehousesComputed.value).filter(f => 
    value.includes(f.value)
  );
}

const props = __props
const onClick = ref<boolean>(false);

const showDetails = ref<boolean>(false)
const iconHasHttp = computed(() => {
  return (props.iconBrand ?? '').includes('http')
})

const goalName = computed(() => {
  let goal_name = goal.value.name;
  if(process.env.VUE_APP_ENVIRONMENT == 'development' || process.env.VUE_APP_ENVIRONMENT == 'stage')
  {
      let aux_goal_name = goal.value.name?.split(' - ');
      goal_name = process.env.VUE_APP_DEFAULT_GOAL_NAME + (aux_goal_name ? ' - ' + aux_goal_name[1] : '');
  }

  return goal_name;
});

const userName = computed(() => {
  return (process.env.VUE_APP_ENVIRONMENT == 'development' || process.env.VUE_APP_ENVIRONMENT == 'stage' ? process.env.VUE_APP_DEFAULT_USER_NAME : goal.value.user?.name);
});

const sellerName = computed(() => {
  return ((process.env.VUE_APP_ENVIRONMENT == 'development' || process.env.VUE_APP_ENVIRONMENT == 'stage') && goal.value.seller?.name ? process.env.VUE_APP_DEFAULT_USER_NAME : goal.value.seller?.name ?? '');
});

const goalGroup = computed(() => {
  return goal.value.goal_group;
});

const usersItemsException = computed(() => {
  return goal.value.users_exceptions?.map(u => { return { image: (u.name ?? '').split(' ').map(x => x[0]).join(''), name:(process.env.VUE_APP_ENVIRONMENT == 'development' || process.env.VUE_APP_ENVIRONMENT == 'stage') && u.name ? process.env.VUE_APP_DEFAULT_USER_NAME : (u.name ?? '') } as IBrandsDetailMeta })
});

const brandItems = computed(() => {
  return goal.value.brands?.map(f => { return { image: f.image_url ? `${process.env.VUE_APP_API_URL.replace('/api', '')}${f.image_url}` : (f.name ?? '').split(' ').map(x => x[0]).join(''), name: f.name } as IBrandsDetailMeta })
});

const brandItemsException = computed(() => {
  return goal.value.brands_exceptions?.map(f => { return { image: f.image_url ? `${process.env.VUE_APP_API_URL.replace('/api', '')}${f.image_url}` : (f.name ?? '').split(' ').map(x => x[0]).join(''), name: f.name } as IBrandsDetailMeta })
});

const resaleItems = computed(() => {
  return goal.value.resales?.map(f => { return { image: (f.sap_card_name ?? '').split(' ').map(x => x[0]).join(''), name: f.sap_card_name } as IBrandsDetailMeta })
});

const resaleItemsException = computed(() => {
  return goal.value.resales_exceptions?.map(f => { return { image: (f.sap_card_name ?? '').split(' ').map(x => x[0]).join(''), name: f.sap_card_name } as IBrandsDetailMeta })
});

const depositItems = computed(() => {
  return goal.value.warehouses?.map(f => { return { image: (f.name ?? '').split(' ').map(x => x[0]).join(''), name: f.name } as IBrandsDetailMeta })
});

const warehouseItemsException = computed(() => {
  return goal.value.warehouses_exceptions?.map(f => { return { image: (f.name ?? '').split(' ').map(x => x[0]).join(''), name: f.name } as IBrandsDetailMeta })
});

const seasonItens = computed(() => {
  const data: ISeasonality[] = []
  if (goal.value.season) {
    Object.keys(goal.value.season).map(x => {
      if (x == 'jan' || x == 'feb' || x == 'mar' || x == 'apr' || x == 'may' || x == 'jun' ||
        x == 'jul' || x == 'aug' || x == 'sep' || x == 'oct' || x == 'nov' || x == 'dec') {
        data.push({
          month:
            x == 'jan' ? 'Jan'
              : x == 'feb' ? 'Fev' : x == 'mar' ? 'Mar' : x == 'apr' ? 'Abr' : x == 'may' ? 'Mai' : x == 'jun' ? 'Jun' : x == 'jul' ? 'Jul'
                : x == 'aug' ? 'Ago'
                  : x == 'sep' ? 'Set'
                    : x == 'oct' ? 'Out'
                      : x == 'nov' ? 'Nov'
                        : x == 'dec' ? 'Dez' : '',
          percentage: formatPercentage(goal.value.season[x]),
          value: formatCurrency(Number(goal.value.value) * (Number(goal.value.season[x]) / 100))
        });
      }
    });
  }
  else {
    for (let i = 0; i < 12; i++) {
      data.push({
        month:
          i == 0 ? 'Jan'
            : i == 1 ? 'Fev' : i == 2 ? 'Mar' : i == 3 ? 'Abr' : i == 4 ? 'Mai' : i == 5 ? 'Jun' : i == 6 ? 'Jul'
              : i == 7 ? 'Ago'
                : i == 8 ? 'Set'
                  : i == 9 ? 'Out'
                    : i == 10 ? 'Nov'
                      : i == 11 ? 'Dez' : '',
        percentage: formatPercentage(0),
        value: formatCurrency(0)
      });
    }
  }

  return data
})

const badgeColor = computed(() => {
  return props.goal.performants_goals?.is_required ? Number(props.progress) >= Number(100) ? '#E6B300' : '#FC4969' : Number(props.progress) >= Number(100) ? '#17CF97' : '#006EE2';
});

const hearderGatilho = computed(() => {
  return (goal.value.triggers_goals ?? []).sort((a, b) => (a?.trigger_item?.order ?? 0) - (b?.trigger_item?.order ?? 0)).map(f => {

    return `${formatTriggerItemPercentageLabel(Number(f.trigger_item?.start_value ?? 0), Number(f.trigger_item?.end_value ?? 0))}`;
  })
})

const itemsGatilho = computed(() => {
  return (goal.value.triggers_goals ?? []).sort((a, b) => (a?.trigger_item?.order ?? 0) - (b?.trigger_item?.order ?? 0)).map(f => {
    return formatPercentage(f.value);
  })
})

const hearders = ref<IHeadersTable[]>([
  { label: 'Bônus', field: 'bonus', type: 'text' },
  { label: 'Margem', field: 'margin' },
  {
    label: 'Período', field: 'period',
    extra: {
      composite: ['start_date', 'end_date'],
      join: 'até'
    }
  },
  { label: 'Obrigatório', field: 'isRequired', type: 'checkbox' },
  { label: 'Cross', field: 'cross', type: 'checkbox' },
  { label: 'Transf', field: 'transfer', type: 'checkbox' },
  { label: 'Privado', field: 'is_corporate', type: 'checkbox' },
  { label: 'Gov', field: 'is_gov', type: 'checkbox' },
  { label: 'Saldão', field: 'sale', type: 'text' },
]);

const items = computed(() => {
  return [{
    margin: formatCurrency(Number(goal.value.value)),
    start_date: format(new Date(`${goal.value.start_date}T00:00:00`), 'dd/MM/yyyy'),
    end_date: format(new Date(`${goal.value.end_date}T00:00:00`), 'dd/MM/yyyy'),
    isRequired: goal.value.performants_goals?.is_required == 1,
    cross: goal.value.is_cross == 1,
    transfer: goal.value.is_transfer == 1,
    is_corporate: goal.value.is_corporate == 1,
    is_gov: goal.value.is_gov == 1,
    sale: goal.value.is_clearance_sale ? `${formatPercentage(goal.value?.clearance_sale_reward ?? 0)}` : undefined,
    bonus: goal.value.is_bonus_goal ? `${formatPercentage(goal.value?.bonus_reward ?? 0)}` : undefined
  }]
})

const { goal } = toRefs(props)

function handleFinishGoal(event) {
  Preloader.actions.ActionSetPreloader(true);

  goal.value.reason = event.reason;
  goal.value.end_date = event.end_date;
  goal.value.skip = event.skip;

  update(goal.value.id as number, goal.value).then(f => {
    Swal.fire({
      text: "Meta encerrada com sucesso",
      title: "Sucesso",
      icon: 'success'
    });
    emit('handleLoad');
    showDetails.value = false;

    if(event.copy_goal.value)
    {
      Preloader.actions.SetGoalId(goal.value.id!);
      router.push({
        name: "CadastrarMetas"
      });
    }
    else
    {
      window.location.reload();
    }
  }).finally(() => {
    Preloader.actions.ActionSetPreloader(true);
  });
}

watch(
  () => showDetails.value,
  () => {
    if(!showDetails.value)
    {
      // Limpa os dados
      can_edit_brands.value = false;
      brands_to_add.value = [];
      brands.value = [];
    }
  }
);

return (_ctx: any,_cache: any) => {
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_textarea = _resolveComponent("v-textarea")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "card-meta cursor-pointer",
      onClick: _cache[2] || (_cache[2] = ($event: any) => (showDetails.value = true))
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_v_avatar, {
            color: "grey",
            size: "30",
            rounded: "0",
            class: "icon-datalogic me-3 mt-1",
            style: {"border-radius":"15% !important"}
          }, {
            default: _withCtx(() => [
              (iconHasHttp.value)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    style: {"width":"100%","height":"100%"},
                    src: `${props.iconBrand ?? ''}`,
                    crossorigin: "anonymous"
                  }, null, 8, _hoisted_3))
                : (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString((props.iconBrand ?? 'T').toUpperCase()), 1))
            ]),
            _: 1
          }),
          _createVNode(_component_v_menu, {
            "open-on-hover": "",
            class: "molecule-menu"
          }, {
            activator: _withCtx(({ props: activatorProps }) => [
              (props.orientation.length)
                ? (_openBlock(), _createElementBlock("span", _mergeProps({
                    key: 0,
                    type: "button",
                    class: "elipse-red mb-8 mr-1"
                  }, activatorProps, {
                    onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
                  }), "+" + _toDisplayString(props.orientation.length), 17))
                : _createCommentVNode("", true)
            ]),
            default: _withCtx(() => [
              _createVNode(_component_v_list, {
                class: "menu-rounded pa-8",
                style: {"min-width":"319px"}
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.orientation, (item) => {
                    return (_openBlock(), _createBlock(_component_v_list_item, {
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (onClick.value = false)),
                      class: "border-bot py-6 px-0",
                      key: item.name
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_list_item_title, { title: "Option 1" }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_5, [
                              _createVNode(_component_v_avatar, {
                                color: "grey",
                                size: "30",
                                style: {"border-radius":"15% !important"},
                                rounded: "0",
                                class: "icon-datalogic"
                              }, {
                                default: _withCtx(() => [
                                  (item.url.includes('http'))
                                    ? (_openBlock(), _createElementBlock("img", {
                                        key: 0,
                                        style: {"height":"100%","width":"100%"},
                                        src: `${item.url}`,
                                        crossorigin: ""
                                      }, null, 8, _hoisted_6))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(item.url.toUpperCase()), 1))
                                ]),
                                _: 2
                              }, 1024),
                              _createElementVNode("p", _hoisted_8, _toDisplayString(item.name), 1)
                            ])
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createElementVNode("div", null, [
            _createElementVNode("p", _hoisted_9, _toDisplayString(props.name), 1),
            (_unref(Authentication).getters.isMasterOrAdmin.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(props.email), 1))
              : _createCommentVNode("", true)
          ])
        ]),
        (props.isProgress)
          ? (_openBlock(), _createBlock(_unref(AtomProgressBar), {
              key: 0,
              progressColor: `${badgeColor.value}`,
              modelValue: props.progress,
              hasPercent: false,
              hasTitle: false
            }, null, 8, ["progressColor", "modelValue"]))
          : _createCommentVNode("", true),
        (!props.isProgress)
          ? (_openBlock(), _createBlock(_unref(AtomBadge), {
              key: 1,
              text: props.badgeText,
              color: props.badgeTextColor,
              bgColor: props.badgeColor,
              class: "white-space-nowrap"
            }, null, 8, ["text", "color", "bgColor"]))
          : _createCommentVNode("", true),
        (!props.isProgress && _unref(goal).active == 0)
          ? (_openBlock(), _createBlock(_unref(AtomBadge), {
              key: 2,
              text: "META INATIVA",
              color: '#546375',
              bgColor: '#EAECF6',
              class: "white-space-nowrap w-100 mt-2"
            }))
          : _createCommentVNode("", true)
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.row, (item) => {
        return (_openBlock(), _createBlock(_component_v_row, {
          class: "mb-3",
          key: item.text
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, { cols: "5" }, {
              default: _withCtx(() => [
                _createElementVNode("p", _hoisted_11, _toDisplayString(item.text), 1)
              ]),
              _: 2
            }, 1024),
            _createVNode(_component_v_col, {
              cols: "7",
              class: "d-flex justify-end"
            }, {
              default: _withCtx(() => [
                _createElementVNode("p", _hoisted_12, _toDisplayString(item.value), 1)
              ]),
              _: 2
            }, 1024),
            _createVNode(_component_v_divider, { class: "mb-1" })
          ]),
          _: 2
        }, 1024))
      }), 128))
    ]),
    (showDetails.value)
      ? (_openBlock(), _createBlock(_unref(MoleculeModalGoal), {
          key: 0,
          width: "100%",
          onHandleCancelGoal: _cache[23] || (_cache[23] = ($event: any) => {showDetails.value = false;}),
          title: "Detalhamento de Metas",
          show: showDetails.value,
          "btn-close-text": "Cancelar"
        }, {
          body: _withCtx(() => [
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "12",
                  sm: "6",
                  md: "3",
                  lg: "3"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(AtomInput), {
                      label: "Título da Meta",
                      placeholder: "Campanha Ásia",
                      disabled: "",
                      modelValue: goalName.value
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "12",
                  sm: "6",
                  md: "3",
                  lg: "3"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(AtomInput), {
                      label: "Nome do Colaborador",
                      placeholder: "Jorge Henrique",
                      disabled: "",
                      modelValue: userName.value
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                (_unref(Authentication).getters.isMasterOrAdmin.value)
                  ? (_openBlock(), _createBlock(_component_v_col, {
                      key: 0,
                      cols: "12",
                      sm: "6",
                      md: "3",
                      lg: "3"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(AtomInput), {
                          label: "Função",
                          placeholder: "Colaborador",
                          disabled: "",
                          modelValue: _unref(goal).role?.name
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_unref(goal).role?.id === 2)
                  ? (_openBlock(), _createBlock(_component_v_col, {
                      key: 1,
                      cols: "12",
                      sm: "6",
                      md: "3",
                      lg: "3"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(AtomInput), {
                          label: "Vendedor",
                          placeholder: "Nome do vendedor",
                          disabled: "",
                          modelValue: sellerName.value
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_v_col, {
                  cols: "12",
                  sm: "6",
                  md: "3",
                  lg: "3"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(AtomInput), {
                      label: "Orientação da meta",
                      placeholder: "Marca",
                      disabled: "",
                      modelValue: _unref(goal).goal_orientation == 'brand' ? 'Marca' : _unref(goal).goal_orientation == 'resale' ? 'Revenda' : 'Depósito'
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "12",
                  sm: "6",
                  md: "3",
                  lg: "3"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("label", {
                      class: _normalizeClass(_unref(goal).role?.id === 2 ? 'mt-4' : 'mb-2')
                    }, " Status ", 2),
                    _createVNode(_unref(AtomToogleButton), {
                      buttons: actives.value,
                      select: String(_unref(goal).active),
                      disabled: ""
                    }, null, 8, ["buttons", "select"])
                  ]),
                  _: 1
                }),
                (!_unref(goal).active)
                  ? (_openBlock(), _createBlock(_component_v_col, {
                      key: 2,
                      cols: "12",
                      sm: "6",
                      md: "6",
                      lg: "6"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_13,
                        _createVNode(_component_v_textarea, {
                          modelValue: _unref(goal).reason,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(goal).reason) = $event)),
                          disabled: "",
                          rows: 1
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (goalGroup.value)
                  ? (_openBlock(), _createBlock(_component_v_col, {
                      key: 3,
                      cols: "12",
                      sm: "6",
                      md: "3",
                      lg: "3"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(AtomInput), {
                          label: "Grupo de metas",
                          disabled: "",
                          modelValue: goalGroup.value?.name
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (goalGroup.value)
                  ? (_openBlock(), _createBlock(_component_v_col, {
                      key: 4,
                      cols: "12",
                      sm: "3",
                      md: "3",
                      lg: "3"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_14,
                        _createVNode(_unref(AtomButton), {
                          outlined: "",
                          background: "grey-lighten-3",
                          "hover-color": "var(--color-gray-03)",
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (showModalGoalGroup()))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Ver detalhes do grupo ")
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(MoleculeModalGoalsGroup), {
                          showModal: showGoalGroup.value,
                          onHandleCancel: _cache[5] || (_cache[5] = ($event: any) => {showGoalGroup.value = false;}),
                          group: goalGroup.value
                        }, null, 8, ["showModal", "group"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            (brandItems.value?.length && _unref(Authentication).getters.isMaster.value && !_unref(goal).is_clearance_sale)
              ? (_openBlock(), _createBlock(_component_v_row, { key: 0 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                      cols: "11",
                      class: "my-3"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(AtomInputBrands), {
                          label: "Marcas",
                          items: brandItems.value ?? [],
                          type: 'brand'
                        }, null, 8, ["items"])
                      ]),
                      _: 1
                    }),
                    (brandItems.value?.length && _unref(goal).active && _unref(Authentication).getters.isMaster.value && !_unref(goal).is_clearance_sale)
                      ? (_openBlock(), _createBlock(_component_v_col, {
                          key: 0,
                          cols: "1",
                          class: "my-3 d-flex align-end"
                        }, {
                          default: _withCtx(() => [
                            (!can_edit_brands.value)
                              ? (_openBlock(), _createBlock(_unref(AtomButton), {
                                  key: 0,
                                  background: "tertiary",
                                  "no-hover": "",
                                  outlined: "",
                                  style: {"height":"65%"},
                                  onClick: _cache[6] || (_cache[6] = ($event: any) => (editBrand()))
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" Alterar ")
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (can_edit_brands.value)
              ? (_openBlock(), _createBlock(_component_v_row, { key: 1 }, {
                  default: _withCtx(() => [
                    (!_unref(goal).is_clearance_sale)
                      ? (_openBlock(), _createBlock(_component_v_col, {
                          key: 0,
                          cols: "11"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(AtomSelect), {
                              label: "Marca(s) a ser(em) adicionada(s)",
                              placeholder: "Escolha a(s) Marca(s) para adicionar",
                              options: filteredData.value.length ? filteredData.value : brandsComputed.value,
                              multiple: "",
                              enableLoad: filteredData.value.length ? false : pagination.value.find((p) => p.source === 'user')?.enableToLoad ?? false,
                              onLoad: () => { nextPagination('brand', loadBrands) },
                              modelValue: brands_to_add.value,
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((brands_to_add).value = $event)),
                              "handle-search": filteredSearch
                            }, null, 8, ["options", "enableLoad", "onLoad", "modelValue"])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (brandItems.value?.length && _unref(goal).active && _unref(Authentication).getters.isMaster.value && !_unref(goal).is_clearance_sale)
                      ? (_openBlock(), _createBlock(_component_v_col, {
                          key: 1,
                          cols: "1",
                          class: "d-flex align-end"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(AtomButton), {
                              background: "quaternary",
                              outlined: "",
                              "no-hover": "",
                              onClick: _cache[8] || (_cache[8] = ($event: any) => (handleEditBrand()))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" Salvar ")
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (brandItems.value?.length && !_unref(Authentication).getters.isMaster.value)
              ? (_openBlock(), _createBlock(_component_v_row, { key: 2 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                      cols: "12",
                      class: "my-3"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(AtomInputBrands), {
                          label: "Marcas",
                          items: brandItems.value ?? [],
                          type: 'brand'
                        }, null, 8, ["items"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                (resaleItems.value?.length)
                  ? (_openBlock(), _createBlock(_component_v_col, {
                      key: 0,
                      cols: "12",
                      class: "my-3"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(AtomInputBrands), {
                          label: "Revendas",
                          items: resaleItems.value ?? [],
                          type: 'reseale'
                        }, null, 8, ["items"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (depositItems.value?.length)
                  ? (_openBlock(), _createBlock(_component_v_col, {
                      key: 1,
                      cols: "12",
                      class: "my-3"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(AtomInputBrands), {
                          label: "Depósitos",
                          items: depositItems.value ?? [],
                          type: 'warehouse'
                        }, null, 8, ["items"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "12",
                  sm: "6",
                  md: "3",
                  lg: "3"
                }, {
                  default: _withCtx(() => [
                    _hoisted_15,
                    _createVNode(_unref(AtomToogleButton), {
                      buttons: exceptions.value,
                      select: String(_unref(goal).has_exception),
                      disabled: ""
                    }, null, 8, ["buttons", "select"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            (_unref(Authentication).getters.isMaster.value && _unref(goal).has_exception)
              ? (_openBlock(), _createBlock(_component_v_row, { key: 3 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                      cols: "11",
                      class: "my-3"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(AtomInputBrands), {
                          label: "Exceção de Usuários",
                          items: usersItemsException.value ?? [],
                          type: 'user'
                        }, null, 8, ["items"])
                      ]),
                      _: 1
                    }),
                    (_unref(goal).active && _unref(Authentication).getters.isMaster.value)
                      ? (_openBlock(), _createBlock(_component_v_col, {
                          key: 0,
                          cols: "1",
                          class: "my-3 d-flex align-end"
                        }, {
                          default: _withCtx(() => [
                            (!can_edit_users_exception.value)
                              ? (_openBlock(), _createBlock(_unref(AtomButton), {
                                  key: 0,
                                  background: "tertiary",
                                  "no-hover": "",
                                  outlined: "",
                                  style: {"height":"65%"},
                                  onClick: _cache[9] || (_cache[9] = ($event: any) => (editUserException()))
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" Alterar ")
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (can_edit_users_exception.value && _unref(goal).has_exception)
              ? (_openBlock(), _createBlock(_component_v_row, { key: 4 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, { cols: "11" }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(AtomSelect), {
                          label: "Usuário(s) a ser(em) adicionado(s) na exceção",
                          placeholder: "Escolha o(s) Usuário(s) para adicionar na exceção",
                          options: filteredDataUserException.value.length ? filteredDataUserException.value : usersComputed.value,
                          multiple: "",
                          enableLoad: filteredDataUserException.value.length ? false : pagination.value.find((p) => p.source === 'user')?.enableToLoad ?? false,
                          onLoad: () => { nextPagination('user', loadUsersException) },
                          modelValue: users_exception_to_add.value,
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((users_exception_to_add).value = $event)),
                          "handle-search": filteredSearchUserException
                        }, null, 8, ["options", "enableLoad", "onLoad", "modelValue"])
                      ]),
                      _: 1
                    }),
                    (_unref(goal).active && _unref(Authentication).getters.isMaster.value)
                      ? (_openBlock(), _createBlock(_component_v_col, {
                          key: 0,
                          cols: "1",
                          class: "d-flex align-end"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(AtomButton), {
                              background: "quaternary",
                              outlined: "",
                              "no-hover": "",
                              onClick: _cache[11] || (_cache[11] = ($event: any) => (handleEditUserException()))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" Salvar ")
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (!_unref(Authentication).getters.isMaster.value && _unref(goal).has_exception)
              ? (_openBlock(), _createBlock(_component_v_row, { key: 5 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                      cols: "12",
                      class: "my-3"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(AtomInputBrands), {
                          label: "Exceção de Usuários",
                          items: usersItemsException.value ?? [],
                          type: 'user'
                        }, null, 8, ["items"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_unref(Authentication).getters.isMaster.value && _unref(goal).has_exception)
              ? (_openBlock(), _createBlock(_component_v_row, { key: 6 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                      cols: "11",
                      class: "my-3"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(AtomInputBrands), {
                          label: "Exceção de Marcas",
                          items: brandItemsException.value ?? [],
                          type: 'brand'
                        }, null, 8, ["items"])
                      ]),
                      _: 1
                    }),
                    (_unref(goal).active && _unref(Authentication).getters.isMaster.value)
                      ? (_openBlock(), _createBlock(_component_v_col, {
                          key: 0,
                          cols: "1",
                          class: "my-3 d-flex align-end"
                        }, {
                          default: _withCtx(() => [
                            (!can_edit_brands_exception.value)
                              ? (_openBlock(), _createBlock(_unref(AtomButton), {
                                  key: 0,
                                  background: "tertiary",
                                  "no-hover": "",
                                  outlined: "",
                                  style: {"height":"65%"},
                                  onClick: _cache[12] || (_cache[12] = ($event: any) => (editBrandException()))
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" Alterar ")
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (can_edit_brands_exception.value && _unref(goal).has_exception)
              ? (_openBlock(), _createBlock(_component_v_row, { key: 7 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, { cols: "11" }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(AtomSelect), {
                          label: "Marca(s) a ser(em) adicionada(s) na exceção",
                          placeholder: "Escolha a(s) Marca(s) para adicionar na exceção",
                          options: optionsBrandExceptionComputed.value,
                          multiple: "",
                          enableLoad: filteredDataBrandException.value.length ? false : pagination.value.find((p) => p.source === 'brand')?.enableToLoad ?? false,
                          onLoad: () => { nextPagination('brand', loadBrands) },
                          modelValue: brands_exception_to_add.value,
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((brands_exception_to_add).value = $event)),
                          "handle-search": filteredSearchBrandException,
                          "on-update": handleBrandExceptionSelection
                        }, null, 8, ["options", "enableLoad", "onLoad", "modelValue"])
                      ]),
                      _: 1
                    }),
                    (_unref(goal).active && _unref(Authentication).getters.isMaster.value)
                      ? (_openBlock(), _createBlock(_component_v_col, {
                          key: 0,
                          cols: "1",
                          class: "d-flex align-end"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(AtomButton), {
                              background: "quaternary",
                              outlined: "",
                              "no-hover": "",
                              onClick: _cache[14] || (_cache[14] = ($event: any) => (handleEditBrandException()))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" Salvar ")
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (!_unref(Authentication).getters.isMaster.value && _unref(goal).has_exception)
              ? (_openBlock(), _createBlock(_component_v_row, { key: 8 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                      cols: "12",
                      class: "my-3"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(AtomInputBrands), {
                          label: "Exceção de Marcas",
                          items: brandItemsException.value ?? [],
                          type: 'brand'
                        }, null, 8, ["items"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_unref(Authentication).getters.isMaster.value && _unref(goal).has_exception)
              ? (_openBlock(), _createBlock(_component_v_row, { key: 9 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                      cols: "11",
                      class: "my-3"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(AtomInputBrands), {
                          label: "Exceção de Revendas",
                          items: resaleItemsException.value ?? [],
                          type: 'reseale'
                        }, null, 8, ["items"])
                      ]),
                      _: 1
                    }),
                    (_unref(goal).active && _unref(Authentication).getters.isMaster.value)
                      ? (_openBlock(), _createBlock(_component_v_col, {
                          key: 0,
                          cols: "1",
                          class: "my-3 d-flex align-end"
                        }, {
                          default: _withCtx(() => [
                            (!can_edit_resales_exception.value)
                              ? (_openBlock(), _createBlock(_unref(AtomButton), {
                                  key: 0,
                                  background: "tertiary",
                                  "no-hover": "",
                                  outlined: "",
                                  style: {"height":"65%"},
                                  onClick: _cache[15] || (_cache[15] = ($event: any) => (editResaleException()))
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" Alterar ")
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (can_edit_resales_exception.value && _unref(goal).has_exception)
              ? (_openBlock(), _createBlock(_component_v_row, { key: 10 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, { cols: "11" }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(AtomSelect), {
                          label: "Revenda(s) a ser(em) adicionada(s) na exceção",
                          placeholder: "Escolha a(s) Revenda(s) para adicionar na exceção",
                          options: optionsResaleExceptionComputed.value,
                          multiple: "",
                          enableLoad: filteredDataResaleException.value.length ? false : pagination.value.find((p) => p.source === 'resale')?.enableToLoad ?? false,
                          onLoad: () => { nextPagination('resale', loadResalesException) },
                          modelValue: resales_exception_to_add.value,
                          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((resales_exception_to_add).value = $event)),
                          "handle-search": filteredSearchResaleException,
                          "on-update": handleResaleExceptionSelection
                        }, null, 8, ["options", "enableLoad", "onLoad", "modelValue"])
                      ]),
                      _: 1
                    }),
                    (_unref(goal).active && _unref(Authentication).getters.isMaster.value)
                      ? (_openBlock(), _createBlock(_component_v_col, {
                          key: 0,
                          cols: "1",
                          class: "d-flex align-end"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(AtomButton), {
                              background: "quaternary",
                              outlined: "",
                              "no-hover": "",
                              onClick: _cache[17] || (_cache[17] = ($event: any) => (handleEditResaleException()))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" Salvar ")
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (!_unref(Authentication).getters.isMaster.value && _unref(goal).has_exception)
              ? (_openBlock(), _createBlock(_component_v_row, { key: 11 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                      cols: "12",
                      class: "my-3"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(AtomInputBrands), {
                          label: "Exceção de Revendas",
                          items: resaleItemsException.value ?? [],
                          type: 'reseale'
                        }, null, 8, ["items"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_unref(Authentication).getters.isMaster.value && _unref(goal).has_exception)
              ? (_openBlock(), _createBlock(_component_v_row, { key: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                      cols: "11",
                      class: "my-3"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(AtomInputBrands), {
                          label: "Exceção de Depósito",
                          items: warehouseItemsException.value ?? [],
                          type: 'warehouse'
                        }, null, 8, ["items"])
                      ]),
                      _: 1
                    }),
                    (_unref(goal).active && _unref(Authentication).getters.isMaster.value)
                      ? (_openBlock(), _createBlock(_component_v_col, {
                          key: 0,
                          cols: "1",
                          class: "my-3 d-flex align-end"
                        }, {
                          default: _withCtx(() => [
                            (!can_edit_warehouses_exception.value)
                              ? (_openBlock(), _createBlock(_unref(AtomButton), {
                                  key: 0,
                                  background: "tertiary",
                                  "no-hover": "",
                                  outlined: "",
                                  style: {"height":"65%"},
                                  onClick: _cache[18] || (_cache[18] = ($event: any) => (editWarehouseException()))
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" Alterar ")
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (can_edit_warehouses_exception.value && _unref(goal).has_exception)
              ? (_openBlock(), _createBlock(_component_v_row, { key: 13 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, { cols: "11" }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(AtomSelect), {
                          label: "Depósito(s) a ser(em) adicionado(s) na exceção",
                          placeholder: "Escolha o(s) Depósito(s) para adicionar na exceção",
                          options: optionsWarehouseExceptionComputed.value,
                          multiple: "",
                          enableLoad: filteredDataWarehouseException.value.length ? false : pagination.value.find((p) => p.source === 'warehouse')?.enableToLoad ?? false,
                          onLoad: () => { nextPagination('warehouse', loadWarehousesException) },
                          modelValue: warehouses_exception_to_add.value,
                          "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((warehouses_exception_to_add).value = $event)),
                          "handle-search": filteredSearchWarehousesException,
                          "on-update": handleWarehouseExceptionSelection
                        }, null, 8, ["options", "enableLoad", "onLoad", "modelValue"])
                      ]),
                      _: 1
                    }),
                    (_unref(goal).active && _unref(Authentication).getters.isMaster.value)
                      ? (_openBlock(), _createBlock(_component_v_col, {
                          key: 0,
                          cols: "1",
                          class: "d-flex align-end"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(AtomButton), {
                              background: "quaternary",
                              outlined: "",
                              "no-hover": "",
                              onClick: _cache[20] || (_cache[20] = ($event: any) => (handleEditWarehousesException()))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" Salvar ")
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (!_unref(Authentication).getters.isMaster.value && _unref(goal).has_exception)
              ? (_openBlock(), _createBlock(_component_v_row, { key: 14 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                      cols: "12",
                      class: "my-3"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(AtomInputBrands), {
                          label: "Exceção de Depósitos",
                          items: warehouseItemsException.value ?? [],
                          type: 'warehouse'
                        }, null, 8, ["items"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, null, {
                  default: _withCtx(() => [
                    _hoisted_16,
                    _createVNode(_unref(AtomTableModal), {
                      items: seasonItens.value,
                      style: {"margin-left":"0px","margin-right":"0px"}
                    }, null, 8, ["items"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "4",
                  class: "mt-4"
                }, {
                  default: _withCtx(() => [
                    _hoisted_17,
                    _createVNode(_unref(MoleculeTableSmall), {
                      headers: hearderGatilho.value,
                      items: itemsGatilho.value
                    }, null, 8, ["headers", "items"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "8",
                  class: "mt-3"
                }, {
                  default: _withCtx(() => [
                    _hoisted_18,
                    _createVNode(_unref(MoleculeTableSmallModal2), {
                      headers: hearders.value,
                      items: items.value
                    }, null, 8, ["headers", "items"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "12",
                  class: "d-flex justify-end"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(AtomButton), {
                      background: "transparent",
                      outlined: "",
                      "no-hover": "",
                      onClick: _cache[21] || (_cache[21] = ($event: any) => {showDetails.value = false;})
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Voltar ")
                      ]),
                      _: 1
                    }),
                    (_unref(goal).active && _unref(Authentication).getters.isMaster.value)
                      ? (_openBlock(), _createBlock(_unref(AtomButton), {
                          key: 0,
                          class: "ms-sm-4 btn-confirm",
                          onClick: _cache[22] || (_cache[22] = ($event: any) => {showModal.value = true;})
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Encerrar meta ")
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["show"]))
      : _createCommentVNode("", true),
    _createVNode(_unref(MoleculeModalAlert), {
      "show-alert-confirm": showModal.value,
      icon: 'GoalFinishIcon',
      text: "Deseja encerrar a meta?",
      onCancel: _cache[24] || (_cache[24] = ($event: any) => {showModal.value = false;}),
      onConfirm: handleFinishGoal,
      "is-text": true,
      label: "Digite o motivo do encerramento",
      width: 600
    }, null, 8, ["show-alert-confirm"])
  ], 64))
}
}

})